import $ from 'jquery';
import { onErrorShowMessage } from '~src/errors';

function forceDownload(blob, filename) {
  const a = document.createElement('a');
  a.download = filename;
  a.href = blob;
  // For Firefox https://stackoverflow.com/a/32226068
  document.body.appendChild(a);
  a.click();
  a.remove();
}

// Current blob size limit is around 500MB for browsers
async function downloadResource(url, filename) {
  if (!filename) {
    filename = url.split('\\').pop().split('/').pop();
  }

  const response = await fetch(url, {
    headers: new Headers({
      Origin: location.origin,
    }),
    mode: 'cors',
  });

  const blob = await response.blob();

  const blobUrl = window.URL.createObjectURL(blob);

  forceDownload(blobUrl, filename);
}

export const handleDownloadAttachment = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const editorAttachmentUrl = $(event.currentTarget).data(
    'download-attachment'
  );

  try {
    await downloadResource(editorAttachmentUrl);
  } catch (err) {
    console.error(err);
    onErrorShowMessage();
  }
};
